import store from '@state/store'
import { mapGetters } from 'vuex'
import { PermissionLevel } from '@/shared/constants/permissions/PermissionLevel'
import { PermissionScope } from '@/shared/constants/permissions/PermissionScope'
import { PermissionModifier } from '@/shared/constants/permissions/PermissionModifier'
import { PermissionRequirement } from '@/shared/constants/permissions/PermissionRequirement'
import { hasAccessToRoute } from '@/helpers/permissions-helpers.js'
import routeDefinitions from '@/shared/constants/routes/routeDefinitions'
import { displayNavItem } from '@/services/features/featureDecisions'

export default {
  computed: {
    ...mapGetters({
      featureToggles: 'features/featureToggles',
    }),
    navItems() {
      return this.generateNavItems().filter((navItem) => {
        const isRouteFeatureEnabled = displayNavItem(
          this.featureToggles,
          navItem.to.name
        )

        if (!Object.prototype.hasOwnProperty.call(navItem, 'permissions'))
          return isRouteFeatureEnabled

        return (
          isRouteFeatureEnabled &&
          hasAccessToRoute(
            {
              meta: {
                permissions: navItem.permissions,
              },
            },
            store
          )
        )
      })
    },
  },
  methods: {
    generateNavItems() {
      return [
        {
          key: 'nav-home',
          title: this.$t('home.homePageTitle'),
          icon: 'mdi-home',
          to: { name: routeDefinitions.home.name },
        },
        {
          key: 'nav-candidates',
          title: this.$t('candidates.pageTitle'),
          icon: 'mdi-account-group',
          to: { name: routeDefinitions.candidates.name },
          permissions: {
            requirement: PermissionRequirement.ONE,
            list: [
              {
                level: PermissionLevel.GROUP_AND_BELOW,
                scope: PermissionScope.BOOKING,
                modifier: PermissionModifier.VIEW,
              },
              {
                level: PermissionLevel.SELECTED_CLIENT_AND_BELOW,
                scope: PermissionScope.TIMESHEETS,
                modifier: PermissionModifier.VIEW,
              },
              {
                level: PermissionLevel.GROUP_AND_BELOW,
                scope: PermissionScope.ACCOUNTS,
                modifier: PermissionModifier.VIEW,
              },
            ],
          },
        },
        {
          key: 'nav-pending-approvals',
          title: this.$t('booking.pendingApproval.shortTitle'),
          icon: 'mdi-calendar-check',
          to: { name: routeDefinitions.bookingsPendingApproval.name },
          permissions: {
            requirement: PermissionRequirement.ONE,
            list: [
              {
                level: PermissionLevel.GROUP_AND_BELOW,
                scope: PermissionScope.BOOKING,
                modifier: PermissionModifier.ALL,
              },
              {
                level: PermissionLevel.GROUP_AND_BELOW,
                scope: PermissionScope.PENDING_BOOKING,
                modifier: PermissionModifier.VIEW,
              },
              {
                level: PermissionLevel.GROUP_AND_BELOW,
                scope: PermissionScope.PENDING_BOOKING,
                modifier: PermissionModifier.CREATE,
              },
            ],
          },
        },
        {
          key: 'nav-timesheets',
          title: this.$t('timesheets.pageTitle'),
          icon: 'mdi-clock',
          to: { name: routeDefinitions.timesheets.name },
          permissions: {
            requirement: PermissionRequirement.ALL,
            list: [
              {
                level: PermissionLevel.SELECTED_CLIENT_AND_BELOW,
                scope: PermissionScope.TIMESHEETS,
                modifier: PermissionModifier.VIEW,
              },
            ],
          },
        },
        {
          key: 'nav-finance',
          title: this.$t('finance.financePageTitle'),
          icon: 'mdi-finance',
          to: { name: routeDefinitions.finance.name },
          permissions: {
            requirement: PermissionRequirement.ALL,
            list: [
              {
                level: PermissionLevel.GROUP_AND_BELOW,
                scope: PermissionScope.ACCOUNTS,
                modifier: PermissionModifier.VIEW,
              },
            ],
          },
        },
        {
          key: 'nav-help',
          title: this.$t('help.pageTitle'),
          icon: 'mdi-help-circle',
          to: { name: routeDefinitions.help.name },
        },
      ]
    },

    isActiveNavItem(to) {
      return to.name === this.$route.name
    },
  },
}
